import { render } from "./AppSection.vue?vue&type=template&id=7c95a525&ts=true"
import script from "./AppSection.vue?vue&type=script&lang=ts"
export * from "./AppSection.vue?vue&type=script&lang=ts"

import "./AppSection.vue?vue&type=style&index=0&id=7c95a525&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__